import { styled } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

export default styled(Button)(({}) => ({
    margin: "5px",
    padding: "4px 8px",
    color: "white",
    minHeight: "22px",
    lineHeight: "16px",
    fontSize: "14px",
    backgroundColor: "black",
    border: "3px solid black",
    "&:hover": {
        backgroundColor: "white !important",
        color: "black !important"
    },
    "&:focus": {
        backgroundColor: "white !important",
        color: "black !important"
    },
    fontFamily: "Rakuten Sans UI, Trebuchet MS, Trebuchet, Arial, Helvetica, sans-serif"
}));
